import { Action } from "@ngrx/store";
import { SharedPageTypeEnum } from "src/app/shared/navigation/page-type.enum";
import { navOrdUrl, navOrdDropOffLiftOfTruckUrl, navOrdDropOffPlaceInStackUrl, navOrdPickUpReservedUrl } from "src/app/shared/routing/routing.const";
import { amqSocketActions } from "src/app/store/amq-socket";
import { ActiveMqMap } from "../ord-equipment-map";
import { OrdEquipmentResultExtI } from "../ord-equipment.result.ext";
import { AmqMoveMessageI } from "../amq-move-message.int";
import { AmqRtgSubscriptionConfigI } from "./amq-rtg-subscription-config.interface";
import { AmqSubscriptionTypeEnum } from "./amq-subscription-type.enum";
import { AmqSubscriptionConfigI } from "./amq-subscription-config.interface";
import { AmqSocketActions } from "src/app/store/amq-socket/amq-socket.actions";

export const sharedChannelList: (AmqRtgSubscriptionConfigI | AmqSubscriptionConfigI)[] = [
  {
    activeMqChannel: 'RTG',
    type: AmqSubscriptionTypeEnum.equipmentSubscription,
    page: navOrdUrl,
    map(contents: OrdEquipmentResultExtI): AmqMoveMessageI { return ActiveMqMap.mapEquipmentResult(contents); },
    updateStore(item: AmqMoveMessageI, currentPage: string): Action<string> {

      return AmqSocketActions.received({ result: item });
    },
    checkBeforeDispatch(type: AmqSubscriptionConfigI, item: any): boolean {
      const rtgItem = item as AmqMoveMessageI;
      const typeItem = type as AmqRtgSubscriptionConfigI;
      return true;
    }
  },

];